<template>
    <common-content-spacer height="large" class="alphabet-table">
        <common-buttons v-if="showTopSaveButton" align="right">
            <common-button
                :disabled="minValidation && !checkedValues.length"
                :isProcessing="isSending"
                :label="$t('common.microcopy.save')"
                type="primary"
                @click="saveChanges"
            ></common-button>
        </common-buttons>
        <div class="alphabet-table--wrapper">
            <common-content-spacer height="small">
                <common-content-spacer height="medium">
                    <div v-for="(item, index) in itemsOnTop" :key="index" class="column-item">
                        <checkbox-input
                            :label="item.name"
                            :value="checked(item.id)"
                            @change="selectionChanged(item)"
                        ></checkbox-input>
                    </div>
                </common-content-spacer>
                <common-content-spacer height="large">
                    <div>
                        <common-content-spacer height="large">
                            <div v-for="(value, key) in alhpabetObject" :key="key">
                                <common-content-spacer height="medium">
                                    <span class="alphabet-table--letter">{{ key }}</span>
                                    <div class="alphabet-table--column-wrapper">
                                        <div
                                            v-for="(column, index) in value"
                                            :key="index"
                                            :class="{ 'column-item--border': column.length }"
                                            class="column-item"
                                        >
                                            <common-content-spacer height="small">
                                                <div v-for="(item, i) in column" :key="i">
                                                    <span v-if="item.childs" class="column-item--group-name">
                                                        {{ item.name }}
                                                    </span>
                                                    <checkbox-input
                                                        v-if="!item.childs"
                                                        :label="item.name"
                                                        :value="item.allFlag ? allChecked(item.id, key) : checked(item.id)"
                                                        @change="
                                                            item.allFlag
                                                                ? selectionAllChanged(item.id, key)
                                                                : selectionChanged(item)
                                                        "
                                                    ></checkbox-input>
                                                    <p v-if="showHorizontalLine(key, item)" class="column-item--hr"></p>
                                                </div>
                                            </common-content-spacer>
                                        </div>
                                    </div>
                                </common-content-spacer>
                            </div>
                        </common-content-spacer>
                    </div>
                </common-content-spacer>
            </common-content-spacer>
        </div>
        <div :style="{ bottom: customBottomPosition }" class="alphabet-table__blur"></div>

        <common-buttons>
            <common-button
                :disabled="minValidation && !checkedValues.length"
                :isProcessing="isSending"
                :label="$t('common.microcopy.save')"
                type="primary"
                @click="saveChanges"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    import CheckboxInput from 'components/form-inputs/CheckboxInput'
    import cloneDeep from 'lodash.clonedeep'

    export default {
        components: {
            CheckboxInput,
        },

        props: {
            alhpabetObject: { type: Object, required: true },
            itemsOnTop: { type: Array, default: () => [] },
            prefillValues: { type: Array, default: undefined },
            returnAllData: { type: Boolean, default: false },
            showTopSaveButton: { type: Boolean, default: false },
            minValidation: { type: Boolean, default: true },
            customBottomPosition: { type: String, default: undefined },
        },

        data() {
            return {
                checkedValues: [],
                practice: this.$auth.getPractice(),
                isSending: false,
            }
        },

        methods: {
            checked(id) {
                return this.checkedValues.map((item) => item.id).includes(id)
            },

            allChecked(id, key) {
                const filteredArray = this.findElement(id, key)
                return this.checkIfArrayContainsArray(filteredArray)
            },

            selectionChanged(insurance) {
                if (this.checkedValues.map((item) => item.id).includes(insurance.id)) {
                    this.checkedValues.splice(this.checkedValues.map((item) => item.id).indexOf(insurance.id), 1)
                } else {
                    this.checkedValues.push(insurance)
                }
            },

            selectionAllChanged(id, key) {
                const filteredArray = this.findElement(id, key)
                if (this.checkIfArrayContainsArray(filteredArray)) {
                    this.checkedValues = this.checkedValues.filter((el) => !filteredArray.map((item) => item.id).includes(el.id))
                } else {
                    this.concatLetterArrays(key).forEach((item) => {
                        if (item.parentId === id && !this.checkedValues.map((d) => d.id).includes(item.id)) {
                            this.checkedValues.push(item)
                        }
                    })
                }
            },

            saveChanges() {
                const returnData = this.returnAllData ? this.checkedValues : this.checkedValues.map((item) => item.id)
                this.emitEvent({ name: 'alphabet-selection-save', payload: returnData })
            },

            findElement(id, key) {
                return this.concatLetterArrays(key).filter((item) => item.parentId === id)
            },

            checkIfArrayContainsArray(array) {
                return array.map((item) => item.id).every((val) => this.checkedValues.map((item) => item.id).includes(val))
            },

            concatLetterArrays(key) {
                let mergedColumns = []
                this.alhpabetObject[key].forEach((columnArray) => {
                    mergedColumns = [...mergedColumns, ...columnArray]
                })
                return mergedColumns
            },

            showHorizontalLine(key, item) {
                const mergedColumns = this.concatLetterArrays(key)
                const i = mergedColumns.findIndex((element) => element.id === item.id)
                return item.parentId && mergedColumns[i + 1] && !mergedColumns[i + 1].parentId
            },
        },

        watch: {
            checkedValues(newValue) {
                this.emitEvent({ name: 'alphabet-selection-selection-change', payload: newValue })
            },
        },

        mounted() {
            this.checkedValues = cloneDeep(this.prefillValues)
        },
    }
</script>
